import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { NewRoadmapForm } from "../../../components/NewRoadmapForm/NewRoadmapForm";

export function NewRoadmap() {
  const navigate = useNavigate();

  return (
    <div
      className="rb-root"
      style={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "8vh 1.5rem 3rem",
        overflowY: "auto",
      }}
    >
      <div style={{ width: "100%", maxWidth: 540 }}>
        <button
          onClick={() => navigate("/roadmap/myroadmaps")}
          style={{
            display: "flex", alignItems: "center", gap: 6, fontSize: 13,
            color: "#64748b", background: "none", border: "none",
            cursor: "pointer", padding: 0, marginBottom: 20,
          }}
        >
          <ArrowLeft style={{ width: 13, height: 13 }} />
          My Roadmaps
        </button>

        <NewRoadmapForm onBack={() => navigate("/roadmap/myroadmaps")} />
      </div>
    </div>
  );
}
